import React, { useEffect, useState } from 'react';

import Path from 'routes/Path';
import { FreecodeLoading } from 'components/FreecodePage/FreecodeLoading/FreecodeLoading';
import FreecodePage from 'components/FreecodePage/FreecodePage';
import { editorTypes } from 'components/FreecodePage/FreecodeLayout/FreecodeLayoutConstants';
import { useFreecodeContextRun, useFreecodeContextData, useFreecodeContextLayout } from 'hooks/useContext';
import FreecodeLayout from 'components/FreecodePage/FreecodeLayout/FreecodeLayout';
import ConfirmModal from 'components/Modals/confirmModal';
import useTestTrialRunFunction from './useTestTrialRunFunction';
import useTestTrialLoadFunction from './useTestTrialLoadFunction';

const HEADER_LINKS = [{ link: Path.candidateTicketsPage, label: 'Your Tests' }];

const submitModalMessage =
  'Are you sure you want to submit your solution? You can repeat the Trial Test as many times as you like, however when submitting during a real test you will not be able to continue working on your code.';

export default function FreecodeTestTrial() {
  const [submitted, setSubmitted] = useState(false);
  const [submittedText, setSubmittedText] = useState(undefined);
  const [errorLinkText, setErrorLinkText] = useState('Go to home page');
  const [errorLink, setErrorLink] = useState(Path.landingPage);

  const { displaySubmit, setDisplaySubmit, setEditorType } = useFreecodeContextLayout();
  const { test } = useFreecodeContextData();
  const { language, codeSol } = useFreecodeContextRun();

  const { loading, error } = useTestTrialLoadFunction();
  useTestTrialRunFunction();

  useEffect(() => {
    setEditorType(editorTypes.freecodeTrial);
  }, [setEditorType]);

  useEffect(() => {
    // For the trial test, save latest code in localstorage. something that is not done for regular code tests.
    if (test?._id && codeSol) localStorage.setItem(`fsEditor-${test.category}-${test._id}-${language}`, codeSol);
  }, [test?._id, codeSol, test?.category, language]);

  const performTrialSubmit = () => {
    setErrorLink(Path.candidateTicketsPage);
    setErrorLinkText('Go to tests');
    setDisplaySubmit(false);
    setSubmitted(true);
    setSubmittedText('Now you can close this tab and start taking your tests');
  };

  return (
    <FreecodePage headerLinks={HEADER_LINKS}>
      <FreecodeLoading
        loading={loading || submitted}
        errors={[error, submittedText]}
        errorLinkText={errorLinkText}
        errorLink={errorLink}
      />
      {!loading && !submitted && <FreecodeLayout />}
      {displaySubmit && (
        <ConfirmModal
          isFreecodeModal
          title="Submit"
          text={submitModalMessage}
          onConfirm={performTrialSubmit}
          onCancel={() => setDisplaySubmit(false)}
        />
      )}
    </FreecodePage>
  );
}
